export const PREMIUM_LOGO_TEXT = 'premium.logo';
